import { createSelector } from 'reselect'
import { IStore } from '../../index'

export function modals(state: IStore) {
  return state.modal.modals
}

const getModals = createSelector(
  [modals],
  modals => modals,
)

const tooltips = (state: IStore) => {
  return state.modal.tooltips
}

const getTooltips = createSelector(
  [tooltips],
  tooltips => tooltips,
)

const getModalIsHidden = (state: IStore) => state.modal.hideModal

export { tooltips, getTooltips, getModalIsHidden }
export default getModals
